/*! caption.js */

/**
 * @constructor
 */
class Caption {

    /**
     * @constructs Caption
     * @param {string} url
     */
    constructor({ url = null }) {
        this.url = url;
    }

    /**
     * @returns {string|null}
     */
    getUrl() {
        return this.url;
    }
}

export default Caption;
